import axios from '../../axios/axios';
import * as actionTypes from '../constants/rabbitActionTypes';
import { validateObj } from '../../utils';

const getRabbitSignTemplatesStart = () => {
  return {
    type: actionTypes.GET_RABBIT_SIGN_TEMPLATES_START,
  };
};

const getRabbitSignTemplatesSuccess = (data) => {
  return {
    type: actionTypes.GET_RABBIT_SIGN_TEMPLATES_SUCCESS,
    rabbitSignTemplatesLookup: data,
  };
};

const getRabbitSignTemplatesError = (error) => {
  return {
    type: actionTypes.GET_RABBIT_SIGN_TEMPLATES_FAIL,
    error: error,
  };
};

export const getRabbitSignTemplates = (lookupParams) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(getRabbitSignTemplatesStart());
      const url = `/rabbit-sign-templates/lookup`;
      axios
        .post(url, validateObj(lookupParams))
        .then((response) => {
          dispatch(getRabbitSignTemplatesSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getRabbitSignTemplatesError(err));
          reject(err);
        });
    });
  };
};

const saveRabbitSignTemplateStart = () => {
  return {
    type: actionTypes.SAVE_RABBIT_SIGN_TEMPLATE_START,
  };
};

const saveRabbitSignTemplateSuccess = (data) => {
  return {
    type: actionTypes.SAVE_RABBIT_SIGN_TEMPLATE_SUCCESS,
    saveRabbitSignTemplate: data,
  };
};

const saveRabbitSignTemplateError = (error) => {
  return {
    type: actionTypes.SAVE_RABBIT_SIGN_TEMPLATE_FAIL,
    error: error,
  };
};

export const saveRabbitSignTemplate = (rabbitSignTemplate) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(saveRabbitSignTemplateStart());
      const url = `/rabbit-sign-templates/save`;
      axios
        .post(url, validateObj(rabbitSignTemplate))
        .then((response) => {
          dispatch(saveRabbitSignTemplateSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(saveRabbitSignTemplateError(err));
          reject(err);
        });
    });
  };
};

const deleteRabbitSignTemplateStart = () => {
  return {
    type: actionTypes.DELETE_RABBIT_SIGN_TEMPLATE_START,
  };
};

const deleteRabbitSignTemplateSuccess = (data) => {
  return {
    type: actionTypes.DELETE_RABBIT_SIGN_TEMPLATE_SUCCESS,
    deleteRabbitSignTemplate: data,
  };
};

const deleteRabbitSignTemplateError = (error) => {
  return {
    type: actionTypes.DELETE_RABBIT_SIGN_TEMPLATE_FAIL,
    error: error,
  };
};

export const deleteRabbitSignTemplate = (id) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(deleteRabbitSignTemplateStart());
      const url = `/rabbit-sign-templates/delete/${id}`;
      axios
        .delete(url)
        .then((response) => {
          dispatch(deleteRabbitSignTemplateSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(deleteRabbitSignTemplateError(err));
          reject(err);
        });
    });
  };
};

const getRabbitSignTemplateByIdStart = () => {
  return {
    type: actionTypes.GET_RABBIT_SIGN_TEMPLATE_BY_ID_START,
  };
};

const getRabbitSignTemplateByIdSuccess = (data) => {
  return {
    type: actionTypes.GET_RABBIT_SIGN_TEMPLATE_BY_ID_SUCCESS,
    rabbitSignTemplate: data,
  };
};

const getRabbitSignTemplateByIdError = (error) => {
  return {
    type: actionTypes.GET_RABBIT_SIGN_TEMPLATE_BY_ID_FAIL,
    error: error,
  };
};

export const getRabbitSignTemplateById = (id) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(getRabbitSignTemplateByIdStart());
      const url = `/rabbit-sign-templates/byid/${id}`;
      axios
        .get(url)
        .then((response) => {
          dispatch(getRabbitSignTemplateByIdSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getRabbitSignTemplateByIdError(err));
          reject(err);
        });
    });
  };
};

const validateRabbitSignSubscriptionStart = () => {
  return {
    type: actionTypes.VALIDATE_RABBIT_SIGN_SUBSCRIPTION_START,
  };
};

const validateRabbitSignSubscriptionSuccess = (data) => {
  return {
    type: actionTypes.VALIDATE_RABBIT_SIGN_SUBSCRIPTION_SUCCESS,
    validateRabbitSignSubscription: data,
  };
};

const validateRabbitSignSubscriptionError = (error) => {
  return {
    type: actionTypes.VALIDATE_RABBIT_SIGN_SUBSCRIPTION_FAIL,
    error: error,
  };
};

export const validateRabbitSignSubscription = () => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(validateRabbitSignSubscriptionStart());
      const url = `/rabbit-sign/validate-subscription`;
      axios
        .get(url)
        .then((response) => {
          dispatch(validateRabbitSignSubscriptionSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(validateRabbitSignSubscriptionError(err));
          reject(err);
        });
    });
  };
};
